import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation, useTranslation } from 'react-i18next';

import { logout } from '../../redux/actions/authActions';

import Icon17 from '../../assets/images/icon17.png';
import Icon18 from '../../assets/images/icon18.png';
import Icon43 from '../../assets/images/icon43.png';

class SiteMap extends React.Component {
  render() {
    const { authStatus, t } = this.props;

    if (authStatus) {
      return (
        <div className="site_map">
          <div className="smc" style={{ cursor: 'pointer' }}>
            <img src={Icon43} alt="" />
          </div>
          <div className="sm_txt">
            <h2>KPNP-ON</h2>
            <p>{t('방문을 환영합니다.')}</p>
          </div>
          <div className="sm_menu">
            <ul>
              <li>
                <Link as="a" to="/mypage">
                  <img src={Icon18} alt="" />
                  {t('내정보')}
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    this.props.logout();
                  }}
                >
                  <img src={Icon17} alt="" />
                  {t('로그아웃')}
                </a>
              </li>
            </ul>
          </div>
          <div className="sm_list">
            <ul>
              <li>
                <Link as="a" to="/event">
                  {t('대회')}
                </Link>
              </li>
              {/* <li>
                <a href="poomsae_list.html">ONLINE POOMSAE</a>
              </li> */}
              <li>
                <a href="http://www.kpnp.net" target="_blank" rel="noreferrer">
                  KPNP
                </a>
              </li>

              {authStatus &&
              this.props.user.userRole.find(
                item =>
                  item === 'judge' ||
                  item === 'site_operator' ||
                  item === 'site_admin',
              ) ? (
                <li>
                  <Link as="a" to="/competition/REF_DEMO">
                    {t('채점 시스템 체험')}
                  </Link>
                </li>
              ) : null}

              {/* <li>
                <a href="/community">COMMUNITY</a>
              </li> */}
            </ul>
          </div>
          <p>KPNP ⒞ All rights reserved.</p>
        </div>
      );
    }
    return (
      <div className="site_map">
        <div className="smc">
          <img src={Icon43} alt="" />
        </div>
        <div className="sm_txt">
          <h2>KPNP-ON</h2>
          <p>{t('방문을 환영합니다.')}</p>
        </div>
        <div className="sm_menu">
          <ul>
            <li>
              <Link as="a" to="/login">
                <img src={Icon17} alt="" />
                {t('로그인')}
              </Link>
            </li>
            <li>
              <Link as="a" to="/join_agree">
                <img src={Icon18} alt="" />
                {t('회원가입')}
              </Link>
            </li>
          </ul>
        </div>
        <div className="sm_list">
          <ul>
            <li>
              <Link as="a" to="/event">
                EVENT
              </Link>
            </li>
            {/* <li>
                <a href="poomsae_list.html">ONLINE POOMSAE</a>
              </li> */}
            <li>
              <Link as="a" to="/kpnp">
                KPNP
              </Link>
            </li>
            {/* <li>
              <a href="/community">COMMUNITY</a>
            </li> */}
          </ul>
        </div>
        <p>KPNP ⒞ All rights reserved.</p>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    authStatus: state.auth.login.login,
    profile: state.auth.login.values,
    user: state.auth.login,
  };
};

export default connect(mapStateToProps, { logout })(withTranslation()(SiteMap));
